export default "__VITE_ASSET__Cmi097xT__"